import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import Layout from '@ui/Layouts/Survey'
import BannerCrosschq from '@ui/Banner'
import Loader from '@ui/Loader'
import queryString from 'query-string'
import Topnav from '../Topnav'
import Steps from './Steps'

@inject('surveyState')
@observer
export default class Survey extends Component {
  state = {
    loading: true
  }

  async componentDidMount() {
    const { surveyState } = this.props
    const { brand_color, brand_logo } = queryString.parse(location.search) || {}

    if (!brand_color && !brand_logo) {
      await surveyState.getCustomization()
    } else {
      surveyState.setCustomization({ brand_color, brand_logo })
    }

    this.setState({ loading: false })
  }

  render() {
    const { onNext, onFinish, surveyState, retrieving, updating } = this.props
    const { showBanner, showAll } = surveyState
    const { loading } = this.state

    if (loading) return <Loader />

    return (
      <Layout all={showAll} retrieving={retrieving}>
        <Layout.Topnav>
          {showBanner && <BannerCrosschq survey />}
          <Topnav hideProgress={showAll} />
        </Layout.Topnav>
        <Layout.Main>
          <Steps onNext={onNext} onFinish={onFinish} loading={updating} />
        </Layout.Main>
      </Layout>
    )
  }
}
